export default "__VITE_ASSET__e91c6b53__"